import React from 'react';
import styled from 'styled-components';
import MotifInlineMessage from '@ey/motif-react-wrapper/InlineMessage';

export default function InlineMessage(props) {
	const {id, className, children, variant, icon} = props;
	const icons = {message: icon};
	return (
		<StyledMotifInlineMessage id={id} className={className} variant={variant} icons={icons}>
			{children}
		</StyledMotifInlineMessage>
	);
}

const StyledMotifInlineMessage = styled(MotifInlineMessage)``;
